"use client"
import React, {ReactNode} from "react";
import {cn} from "@/lib/utils";

export function TextButton(
  {onClick, disabled, children, icon, className}:
  { onClick?: (e: React.MouseEvent<HTMLDivElement>) => void, disabled?: boolean, children?: ReactNode, icon?: ReactNode, className?: string },
) {
  return <div
    tabIndex={0}
    className={cn(
      "text-sm font-semibold opacity-40 flex gap-2 items-center cursor-default transition-opacity",
      !disabled && "hover:opacity-100",
      className)}
    onClick={(e) => {
      if (!disabled && onClick) {
        onClick(e)
      }
    }}
  >{icon && <div className="w-4 h-4 flex items-center">{icon}</div>}{children}
  </div>
}